module.exports = __webpack_public_path__ + "img/no_blocks.625dbdcc.svg";